import React from 'react';

const CenteredMessage = ({ message, onClose }) => {
  return (
    <div className="notification-container">
      <div className="notification-box">
        <p>{message}</p>
        <button onClick={onClose}>Try Again</button>
      </div>
    </div>
  );
};

export default CenteredMessage;
